import { render, staticRenderFns } from "./viewNewsletter.vue?vue&type=template&id=62d759ef&scoped=true&"
import script from "./viewNewsletter.vue?vue&type=script&lang=js&"
export * from "./viewNewsletter.vue?vue&type=script&lang=js&"
import style0 from "./viewNewsletter.vue?vue&type=style&index=0&id=62d759ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d759ef",
  null
  
)

export default component.exports